
export const zoomFitNodesSvc = (cy: any) => {
  if (cy && typeof cy.fit === 'function') cy.fit();
};
